import {t} from "i18next";
import {Tooltip} from "antd";
import {ApiOutlined} from "@ant-design/icons";
import {MdOutlineBackHand} from "react-icons/md";

// İstemin kaynağı: HL7 ile gelen (fiş, amber) ya da elle eklenen (el, gri).
// İstem gridi ve rapor gridi aynı ikonu kullanır.
export default function RequestSourceIcon({isHL7}) {
    return (
        <Tooltip title={t(isHL7 ? 'Added via HL7' : 'Added manually')}>
            <span style={{ display: 'inline-flex', flex: 'none', fontSize: 14, color: isHL7 ? 'var(--accent-dark)' : '#888' }}>
                {isHL7 ? <ApiOutlined /> : <MdOutlineBackHand />}
            </span>
        </Tooltip>
    );
}
